import React from "react";
import { AuthUserContext, withAuthorization } from "../../Auth/Session";
import Metabase from "../Metabase";
import { validateMetaLanguage } from "../../../utils/validateMetaLanguage";

class TopIndicators extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <Metabase dashboardId={validateMetaLanguage(882)} />
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(TopIndicators);